/** 是否在企业微信客户端内置浏览器中打开 */
export function isWeComClient(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /wxwork/i.test(navigator.userAgent);
}

const REDIRECT_KEY = 'erp_post_login_redirect';
const OAUTH_ATTEMPT_KEY = 'erp_wecom_oauth_attempt';
const SENSITIVE_ATTEMPT_KEY = 'erp_wecom_sensitive_attempt';

const LOGIN_PATHS = ['/user/login', '/user/register', '/user/register-result'];

function isSafeInternalPath(path: string): boolean {
  if (!path.startsWith('/') || path.startsWith('//')) return false;
  const pathname = path.split('?')[0].split('#')[0];
  if (LOGIN_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`))) {
    return false;
  }
  return true;
}

/** 跳转企微 OAuth 前暂存登录后去向（回调 URI 通常不含 query） */
export function stashLoginRedirect(redirect: string | null | undefined) {
  if (typeof sessionStorage === 'undefined') return;
  if (redirect && isSafeInternalPath(redirect)) {
    sessionStorage.setItem(REDIRECT_KEY, redirect);
  }
}

export function takeStashedLoginRedirect(): string | null {
  if (typeof sessionStorage === 'undefined') return null;
  const v = sessionStorage.getItem(REDIRECT_KEY);
  sessionStorage.removeItem(REDIRECT_KEY);
  if (v && isSafeInternalPath(v)) return v;
  return null;
}

export function clearLoginRedirect() {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(REDIRECT_KEY);
}

export function markWecomOAuthAttempted() {
  sessionStorage.setItem(OAUTH_ATTEMPT_KEY, String(Date.now()));
}

export function clearWecomOAuthAttempt() {
  sessionStorage.removeItem(OAUTH_ATTEMPT_KEY);
}

/** 同一会话内是否已尝试过自动 OAuth（避免授权拒绝后死循环） */
export function hasRecentWecomOAuthAttempt(withinMs = 3 * 60 * 1000): boolean {
  const raw = sessionStorage.getItem(OAUTH_ATTEMPT_KEY);
  if (!raw) return false;
  const t = Number(raw);
  if (!Number.isFinite(t)) return true;
  return Date.now() - t < withinMs;
}

export function markSensitiveAuthAttempted() {
  sessionStorage.setItem(SENSITIVE_ATTEMPT_KEY, String(Date.now()));
}

export function hasRecentSensitiveAuthAttempt(
  withinMs = 30 * 60 * 1000,
): boolean {
  const raw = sessionStorage.getItem(SENSITIVE_ATTEMPT_KEY);
  if (!raw) return false;
  const t = Number(raw);
  if (!Number.isFinite(t)) return true;
  return Date.now() - t < withinMs;
}

export function clearSensitiveAuthAttempt() {
  sessionStorage.removeItem(SENSITIVE_ATTEMPT_KEY);
}
